import styled from '@emotion/styled';

export const Link = styled('a')(({ theme }) => ({
  textDecoration: `underline ${theme.text._4}`,
}));
